/* eslint-disable */
import axios from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
axios.defaults.withCredentials = true;

const http = axios.create({
  baseURL: process.env.VUE_APP_API4D_URL,
  headers: { 'Cache-Control': 'no-cache' },
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
})

const API = {
  LISTEPUBLICATION: '/publications',
  LISTEREVUESANNEE: '/revue/:publication',
  BINAIREPDF: '/binairepdf',
  RECHERCHE: '/search',
}

function url(path, ...segments) {
  let i = 0
  const uri = path.replace(/:\w+/g, () => {
    let s = segments[i]
    i += 1
    return s
  })

  return uri
}

export default {
  install(app) {
    const $api4d = {
      getPublications(token) {
        return http.post(url(API.LISTEPUBLICATION), { token: token })
      },
      getRecherche(token, filters) {
        return http.post(url(API.RECHERCHE), { token: token, filters: filters })
      },
      getListeRevuesAnnee(token, publication) {
        return http.post(url(API.LISTEREVUESANNEE, publication), { token: token })
      },
      getNumRevuesAnnee(token, publication, year) {
        return http.post(url(API.LISTEREVUESANNEE, publication) + '/' + year, { token: token })
      },
      getRevuesCover(token, publication, year, issue) {
        return http.post(url(API.LISTEREVUESANNEE, publication) + '/' + year + '/' + issue, { token: token })
      },
      getBinairePdf(token, id) {
        return http.post(url(API.BINAIREPDF), { token: token, id: id }, { responseType: 'blob' })
      },
    }

    app.config.globalProperties.$api4d = $api4d
  }
}
